import React from 'react';
import { useTranslation } from 'react-i18next';
import 'react-modal-video/scss/modal-video.scss';
import LazyLoad from 'react-lazyload';
import Bubble from '../components/bubbleComp'

const ContactContent = () => {

    const { t } = useTranslation();

    return (

        <section id="contact-page" className="home home-one contact-bg">
            <div className="container">
            <div className="home-decor">
                <div className="home-circle2 circle-shadow ">
                    <Bubble aling="right" elem={<LazyLoad><img src="assets/images/ourmind-logo-head.png" alt="" /></LazyLoad>} text={`${t('hi')}!`} />
                </div>
            </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="home-contain">
                            <div>
                            <h2 className="title pink-title text-center text-md-left mt-5"><span>{t('new dimension of knowledge')}</span></h2>
                                <p style={{maxWidth: '500px'}} className="caption-about caption-contact">{t('contact text')}</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactContent


// WEBPACK FOOTER //
// ./src/components/contactContent.js